import { parseAsArrayOf, parseAsString } from "nuqs";

import { usePersistedQueryStates } from "@/src/hooks/use-persisted-query-states";

export const taskQueryParams = {
  assignedToUser: parseAsArrayOf(parseAsString, ","),
  priority: parseAsArrayOf(parseAsString, ","),
  status: parseAsArrayOf(parseAsString, ","),
  tags: parseAsArrayOf(parseAsString, ","),
  type: parseAsArrayOf(parseAsString, ","),
  documentClassification: parseAsArrayOf(parseAsString, ","),
  source: parseAsArrayOf(parseAsString, ","),
};

export function useTaskColumnFilters() {
  return usePersistedQueryStates(taskQueryParams);
}
